import i18n from '@i18next/i18n';
import { ElementBaseAccessibilityContent } from './base';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IAccessibilityManagerContentHandler } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';

export class PictureAccessibilityContent extends ElementBaseAccessibilityContent {
    private pictureModel: IPictureModel;
    public constructor(model: IPictureModel, a11yManager: IAccessibilityManagerContentHandler) {
        super(model, a11yManager);
        this.pictureModel = model;
    }

    public getAccessibilityContent(isSelected = false, content = ''): string {
        return super.getAccessibilityContent(false, i18n.t('图片'));
    }
}
